import { create } from 'zustand';

export interface CommandItem {
  id: string;
  label: string;
  description?: string;
  section: string;
  action: () => void;
  keywords?: string[];
}

interface CommandState {
  open: boolean;
  query: string;
  commands: CommandItem[];
  toggle: () => void;
  setOpen: (open: boolean) => void;
  setQuery: (query: string) => void;
  register: (commands: CommandItem[]) => void;
}

export const useCommandStore = create<CommandState>((set) => ({
  open: false,
  query: '',
  commands: [],
  toggle: () => set((s) => ({ open: !s.open, query: '' })),
  setOpen: (open) => set({ open, query: '' }),
  setQuery: (query) => set({ query }),
  register: (commands) =>
    set((s) => {
      const ids = new Set(commands.map((c) => c.id));
      const filtered = s.commands.filter((c) => !ids.has(c.id));
      return { commands: [...filtered, ...commands] };
    }),
}));
